import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import loadNamespaces from 'next-translate/loadNamespaces';
import { useIsMobile } from '../../style/constants';
import { Container } from '../../VuexyDesign/atoms/_index';
import FAQ from '../../components/HowItWorks/FAQ';
import StatisticsHeroSection from '../../components/HowItWorks/StatisticsHeroSection';
import BrowserPageTitle from '../../components/common/BrowserPageTitle';
import {
  HowItWorksRowDesktop,
  HowItWorksRowMobile,
} from '../../VuexyDesign/organisms/_index';
import { statistics } from '../../components/HowItWorks/AccordionContent';
import { VirpPageContext } from '../_app';

const howTos = [
  {
    key: 1,
    headerTitle: 'howItWorks:statisticsPage.headerTitle.statisticsPage',
    title: 'howItWorks:statisticsPage.goToStatistics',
    subtitle: 'howItWorks:statisticsPageDescriptions.goToStatistics',
    media: '/static/animations/profilemenu.json',
    leftColumn: '7',
    rightColumn: '5',
    picture: true,
    videoLeft: false,
  },
  {
    key: 2,
    headerTitle: 'howItWorks:statisticsPage.headerTitle.trackStatistics',
    title: 'howItWorks:statisticsPage.seeStatistics',
    subtitle: 'howItWorks:statisticsPageDescriptions.seeStatistics',
    media: '/static/animations/listeningmusic.json',
    leftColumn: '6',
    rightColumn: '5',
    picture: true,
    videoLeft: true,
  },
  {
    key: 3,
    headerTitle: 'howItWorks:statisticsPage.headerTitle.labelActivity',
    title: 'howItWorks:statisticsPage.labelActivity',
    subtitle: 'howItWorks:statisticsPageDescriptions.labelActivity',
    media: '/static/animations/labelactivity.json',
    leftColumn: '7',
    rightColumn: '5',
    picture: true,
    videoLeft: false,
  },
  {
    key: 4,
    headerTitle: 'howItWorks:statisticsPage.headerTitle.findYourAudience',
    title: 'howItWorks:statisticsPage.getInsights',
    subtitle: 'howItWorks:statisticsPageDescriptions.getInsights',
    media: '/static/animations/statistics.json',
    leftColumn: '6',
    rightColumn: '5',
    picture: true,
    videoLeft: true,
  },
  {
    key: 5,
    headerTitle: 'howItWorks:statisticsPage.headerTitle.earnings',
    title: 'howItWorks:statisticsPage.seeEarnings',
    subtitle: 'howItWorks:statisticsPageDescriptions.seeEarnings',
    media: '/static/animations/profitanalysis.json',
    leftColumn: '7',
    rightColumn: '5',
    picture: true,
    videoLeft: false,
  },
];

const Index = () => {
  const { t } = useTranslation('howItWorks');
  const isMobile = useIsMobile();

  return (
    <div className="d-flex w-100 justify-content-center align-items-center flex-column">
      <BrowserPageTitle>
        {t('howItWorks:statisticsPage.title')}
      </BrowserPageTitle>
      <Container
        fluid
        className="d-flex align-items-center position-relative px-0"
      >
        <StatisticsHeroSection />
      </Container>
      {howTos.map((howTo) =>
        isMobile ? (
          <HowItWorksRowMobile
            key={howTo.key}
            headerTitle={howTo.headerTitle}
            title={howTo.title}
            subtitle={howTo.subtitle}
            media={howTo.media}
            picture={howTo.picture}
          />
        ) : (
          <HowItWorksRowDesktop
            key={howTo.key}
            headerTitle={howTo.headerTitle}
            title={howTo.title}
            subtitle={howTo.subtitle}
            media={howTo.media}
            leftColumn={howTo.leftColumn}
            rightColumn={howTo.rightColumn}
            videoLeft={howTo.videoLeft}
            picture={howTo.picture}
          />
        ),
      )}

      <FAQ page={statistics} />
    </div>
  );
};

Index.getInitialProps = async (ctx: VirpPageContext) => {
  const getTranslations = await loadNamespaces({
    ...ctx,
    pathname: '/how-it-works/statistics',
  });
  return { ...getTranslations };
};

export default Index;
